import { PortalClient } from '@tencent/slide-sdk-portal/src/core/portal';
import { MainThreadTransport } from '@tencent/slide-sdk-portal/src/transport/common/main-thread-transport';

declare global {
    interface Window {
        __globalOfflinePkg: boolean
    }
}

export interface ISlideFileManager {
    recent(): Promise<SlideFileInstance | undefined>;
    recentBack(client: SlideFileInstance): void;
    createInstance(): Promise<SlideFileInstance>;
}

export class SlideFileManager implements ISlideFileManager {
    private maxCount = 1;
    private instancePools: SlideFileInstance[] = [];

    public constructor() {
        this.eliminateLoop();
    }

    public async recent() {
        let instance = this.instancePools.find(i => !i.isAllocated);
        if (instance) {
            instance.allocate();
            return instance;
        }
        if (this.instancePools.length < this.maxCount) {
            instance = await this.createInstance();
            this.instancePools.push(instance);
            instance.allocate();
            return instance;
        }
        return;
    }

    public recentBack(client: SlideFileInstance) {
        if (!(client instanceof SlideFileInstance)) {
            throw Error('client is invalid');
        }
        client.deallocate();
    }


    public async createInstance() {
        const worker = await import('@tencent/slide-sdk-model/src/app/slide-file.worker').then((instance: any) => new (instance.default)());
        const client = new PortalClient<any>(new MainThreadTransport(worker));
        return new SlideFileInstance(client);
    }

    private eliminateLoop() {
        setInterval(() => {
            // 销毁所有未激活的实例，但至少保留一个实例
            let hasRetainedInstance = false;
            this.instancePools = this.instancePools
                .sort((a, b) => {
                    if (a.isActive === b.isActive) return 0;
                    return a.isActive ? -1 : 1;
                })
                .filter((instance) => {
                    if (instance.isActive || !hasRetainedInstance) {
                        // 保留激活的实例
                        // 如果还没有保留实例，保留第一个未激活的实例
                        hasRetainedInstance = true;
                        return true;
                    }
                    // 销毁未激活的实例
                    instance.dispose();
                    return false;
                });
        }, 60000);
    }
}

export class SlideFileInstance {
    public isAllocated = false;
    private lastUsedTimestamp?: number;

    public constructor(private client: PortalClient<any, object>) {}

    public allocate() {
        this.lastUsedTimestamp = Date.now();
        this.isAllocated = true;
    }

    public deallocate() {
        this.isAllocated = false;
    }

    public get slideFile() {
        return this.client.service('SlideFile');
    }

    public get isActive() {
        return this.isRecentlyUsed || this.isAllocated;
    }

    public dispose() {
        this.client.dispose();
    }

    private get isRecentlyUsed() {
        return this.lastUsedTimestamp ? Date.now() - this.lastUsedTimestamp < 60000 : false;
    }
}
